/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

//正浮点数+0
export function number(value){
  var val=value+'';
  var reg=/^\d+(\.\d+)?$/
  if(!reg.test(val)){
    return false;
  }else{
    return true;
  }
}
// 两位小数
export function isFloat2(value){
  var value = value + "";
  const rule1=(/^\d+(\.\d+)?$/);
  if(!rule1.test(value)) return false;
  if(value.indexOf('.')){
    return (/^[0-9]+(.[0-9]{1})?$/).test(value)||(/^[0-9]+(.[0-9]{2})?$/).test(value)
  }
}
// 中文
export function isCN () {
  var val=value+'';
  return (/^[\u4E00-\u9FA5]+$/).test(val);
}
export function isMobile(value){
  var val=value+'';
  if(!val) return false;
  if(val=='undefined') return false;
  if(val.length!=11) return false;
  const reg = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}/g)
  return reg.test(value)
}
export function isEN(value){
  var val=value+'';
  if(!(/^[a-zA-Z]+$/).test(val)) return false;
  return true;
}

export function idCard(value){
  var val=value+'';
  if(!val) return false;
  if(val=='undefined') return false;
  if(val.length!=18) return false;
  var regIdCard=/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  //如果通过该验证，说明身份证格式正确，但准确性还需计算
  if(regIdCard.test(val)){
    if(val.length==18){
      var idCardWi=new Array( 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ); //将前17位加权因子保存在数组里
      var idCardY=new Array( 1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2 ); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
      var idCardWiSum=0; //用来保存前17位各自乖以加权因子后的总和
      for(var i=0;i<17;i++){
        idCardWiSum+=val.substring(i,i+1)*idCardWi[i];
      }
      var idCardMod=idCardWiSum%11;//计算出校验码所在数组的位置
      var idCardLast=val.substring(17);//得到最后一位身份证号码
      //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if(idCardMod==2){
        if(idCardLast=="X"||idCardLast=="x"){
          return true;
        }else{
          return false;
        }
      }else{
        //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if(idCardLast==idCardY[idCardMod]){
          return true;
        }else{
          return false;
        }
      }
    }
  }else{
    return false;
  }
}

// 只能字母和数字组成
export function isNumAndEn(value){
  const reg=/^[A-Za-z0-9]+$/
  return reg.test(value)
}

/**
 * 英文及下划线组成
 */
 export function isEnAndLine(str) {
  const reg=/^[A-Za-z_]+$/
  return reg.test(str)
}
/**
 * 英文数字及下划线组成
 */
 export function isFieldName(str) {
  const reg1=/^[A-Za-z0-9_]+$/  //英文名只能包含字母和下划线
  const reg2=/^[A-Za-z]/ //必须含有字母  且英文开头
  return reg1.test(str)&&reg2.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}





// WEBPACK FOOTER //
// ./src/utils/validate.js